import { createContext, useContext } from 'react'
import { Blocker, BlockerFunction } from 'react-router-dom'

type BlockerContextType = {
  blocker: Blocker
  register: (blockerFn: BlockerFunction) => () => void
}

export const BlockerContext = createContext<BlockerContextType>({
  blocker: {
    state: 'unblocked',
    proceed: undefined,
    reset: undefined,
    location: undefined
  },
  register: () => () => console.log('batata')
})

export const useBlocker = () => useContext(BlockerContext)
